import { ApiResponse } from "@/types/global";
import { AxiosError, AxiosResponse, HttpStatusCode } from "axios";

export function handleApiResponse(
  response: AxiosResponse,
  isPaginated: boolean = false,
): ApiResponse {
  return {
    isSuccess: true,
    statusCode: HttpStatusCode.Ok,
    data: isPaginated ? response.data.items : response.data,
    count: isPaginated ? response.data.count : undefined,
    pages: isPaginated ? response.data.pages : undefined,
    errorMessage: undefined,
  };
}

export function handleApiError(error: unknown): ApiResponse {
  let statusCode = HttpStatusCode.InternalServerError;
  const defaultMessage = "Unknown Error: An error has occurred while processing your request.";
  let errorMessage = defaultMessage;
  if (error instanceof AxiosError) {
    if (!error.response) {
      return {
        isSuccess: false,
        data: undefined,
        count: undefined,
        pages: undefined,
        statusCode: 0,
        errorMessage: "Server unavailable: Please try again after some time.",
      };
    }
    statusCode = error.response.status;
    if (statusCode === HttpStatusCode.BadRequest) {
      errorMessage = "Client error: Possible bad request.";
    } else if (statusCode === HttpStatusCode.Forbidden) {
      errorMessage = "Forbidden: Your session has expired. Please log in again.";
    } else if (statusCode === HttpStatusCode.TooManyRequests) {
      errorMessage = "Rate Limited: Too many requests, please try again later.";
    } else if (statusCode === HttpStatusCode.ServiceUnavailable) {
      errorMessage = "Service unavailable: The server is temporarily under maintenance.";
    } else if (error.message === "Network Error") {
      errorMessage = "No internet connection: Please check your network connection.";
    } else {
      errorMessage = error.response.data.detail ? error.response.data.detail : defaultMessage;
    }
  }
  return {
    isSuccess: false,
    data: undefined,
    count: undefined,
    pages: undefined,
    statusCode: statusCode,
    errorMessage: errorMessage,
  };
}
